enum ModelAlgorithmEnum {
    RIG_STATE_MODEL = 'rig-state-model',
    LEGACY_MODEL = 'legacy-model',
    SIMPLIFIED_MODEL ='simplified-model',
}
export default ModelAlgorithmEnum